import { Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconDownload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import ExcelJS from 'exceljs';

export const DownloadTemplateButton = () => {
  const { t } = useTranslation();

  // 下载模板
  const downloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(t('adminConsole.newConsole.userImportTemplate'));

    // 设置列宽（字符宽度）
    worksheet.columns = [
      { width: 5 }, // 序号列
      { width: 8 }, // 标记列
      { width: 20 }, // 姓名列
      { width: 35 }, // 邮箱列
      { width: 25 }, // 部门列
      { width: 40 }, // 角色列
    ];

    // 第1行：空行（5个空列）
    const row1 = worksheet.addRow(['', '', '', '', '']);
    row1.height = 20; // 设置行高

    // 第2行：模板头部（从翻译的CSV格式解析为多列）
    const row2 = worksheet.addRow(t('adminConsole.newConsole.import.templateHeader').split(','));
    row2.height = 100;
    // 设置头部单元格样式
    row2.eachCell((cell) => {
      cell.alignment = { vertical: 'middle', wrapText: true };
      cell.font = { bold: true };
    });

    // 第3行：示例数据1（日文姓名）
    const row3 = worksheet.addRow(['', '例', '山田　太郎', 'yamada.mark@example.com', '総務部/経理課', '2']);
    row3.height = 25;
    row3.eachCell((cell) => {
      cell.alignment = { vertical: 'middle', wrapText: true };
    });

    // 第4行：示例数据2（英文姓名）
    const row4 = worksheet.addRow(['', '例', 'Lucas', 'arai.lucas@example.com', '営業部/第2営業課', '4']);
    row4.height = 25;
    row4.eachCell((cell) => {
      cell.alignment = { vertical: 'middle', wrapText: true };
    });

    // 生成Excel文件并下载
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${t('adminConsole.newConsole.userImportTemplate')}.xlsx`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    notifications.show({
      message: t('adminConsole.newConsole.templateDownloaded'),
      color: 'green',
    });
  };

  return (
    <Button variant="outline" size="sm" leftSection={<IconDownload size={16} />} onClick={downloadTemplate}>
      {t('adminConsole.newConsole.downloadTemplate')}
    </Button>
  );
};
